/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerCountConfig = {
    properties: {
        KEEPER: {
            type: 'number',
            isRequired: true,
        },
        DEFENDER: {
            type: 'number',
            isRequired: true,
        },
        MIDFIELD: {
            type: 'number',
            isRequired: true,
        },
        OFFENSE: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
